import { observer } from 'mobx-react-lite';

import { FormLabel } from '@components/form-label';
import { Select } from '@components/select';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextArea } from '@components/textarea';

import { useBoolean } from 'hooks/useBoolean';
import { configs } from 'jobboards/configs';
import { useStore } from 'models/Provider';

import { tvinnaStatusChoices } from './constants';

export const PromoteTvinnaForm = observer(({ boardState }) => {
  const { t, lang } = useStore();
  const [touched, { on, off }] = useBoolean(false);
  return (
    <Stack space={6}>
      <Select
        label={t('jobboards.tvinna.title.status')}
        defaultValue={boardState.status}
        isClearable={false}
        isSearchable={false}
        options={tvinnaStatusChoices}
        onChange={boardState.editStatus}
      />

      <TextArea
        label={'* ' + t('jobboards.tvinna.title.extra')}
        value={boardState.extraInfo}
        onChange={boardState.editExtraInfo}
        error={touched && !boardState.extraInfo && t('errors.required')}
        onBlur={on}
        onFocus={off}
      />

      <Separator />
      <FormLabel text={t('jobboards.tvinna.info')} />
      <Text text={configs.tvinna[lang].priceText} />
      <Separator />
    </Stack>
  );
});
